import React from "react";
import { colorTokens, getSpacing } from "../designTokens";
import { CenteredPageLoader } from "../components/common/CenteredPageLoader";

export interface RouteSuspenseFallbackProps {
  message?: string;
  id?: string;
}

/** Full-viewport fallback while a lazy route chunk loads. */
export const RouteSuspenseFallback: React.FC<RouteSuspenseFallbackProps> = ({
  message = "Loading page…",
  id = "route-suspense-fallback",
}) => (
  <div
    id={id}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      width: "100%",
      backgroundColor: colorTokens["Background/Greyish"],
      padding: getSpacing("24px"),
    }}
  >
    <CenteredPageLoader message={message} id={`${id}-loader`} />
  </div>
);
